import {PATHS} from "../../../../routing/paths";
import {
    CEO,
    CONTACT,
    INN,
    KPP,
    LEGAL_ADDRESS,
    OGRN,
    OPERATOR,
    OPERATOR_SHORT,
    SERVICE,
    type LegalDoc,
} from "./common";

/** Политика обработки персональных данных (/privacy). */
export const PRIVACY_DOC: LegalDoc = {
    title: "Политика обработки персональных данных",
    linkLabel: "политика обработки персональных данных",
    path: PATHS.privacy,
    updated: "16 сентября 2026 г.",
    sections: [
        {
            title: "1. Общие положения",
            body: [
                `Настоящая Политика определяет порядок обработки и защиты персональных данных пользователей сервиса знакомств ${SERVICE} (далее — Сервис) в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и требованиями Роскомнадзора.`,
                `Оператор персональных данных: ${OPERATOR}, ИНН ${INN}, КПП ${KPP}, ОГРН ${OGRN}, юридический адрес: ${LEGAL_ADDRESS}, генеральный директор: ${CEO}.`,
                `Контактные данные оператора: ${CONTACT}.`,
                "Используя Сервис, вы соглашаетесь с условиями настоящей Политики. Если вы не согласны — пожалуйста, прекратите использование Сервиса.",
            ],
        },
        {
            title: "2. Какие данные мы обрабатываем",
            body: [
                "Данные учётной записи: адрес электронной почты, номер телефона, пароль (в зашифрованном виде).",
                "Данные профиля: имя, дата и место рождения, пол, фотографии, город, интересы, сведения анкеты (в том числе указанные добровольно: время и город рождения, образ жизни).",
                "Технические данные: IP-адрес, сведения об устройстве и браузере, файлы cookie, данные о действиях в Сервисе.",
                "Данные мобильного устройства при использовании мобильного приложения: модель устройства, версия операционной системы, версия приложения, идентификаторы приложения и устройства (в том числе push-токен), технические данные о работе приложения (сбои, события использования).",
                "Геолокация — только с вашего явного разрешения, для поиска анкет поблизости.",
            ],
        },
        {
            title: "3. Цели обработки",
            body: [
                "Предоставление функций Сервиса: создание профиля, подбор анкет, обмен сообщениями, расчёт совместимости.",
                "Обеспечение работы мобильного приложения: аутентификация, синхронизация данных между веб-версией и мобильным приложением, доставка push-уведомлений (в том числе через RuStore Push) о сообщениях, событиях и статусах в Сервисе.",
                "Обеспечение безопасности пользователей, рассмотрение жалоб и обращений в поддержку.",
                "Отправка новостной, информационной и рекламной рассылки — при наличии отдельного согласия.",
                "Исполнение требований законодательства Российской Федерации, в том числе взаимодействие с Роскомнадзором и иными уполномоченными органами.",
            ],
        },
        {
            title: "4. Правовые основания обработки",
            body: [
                "Согласие субъекта персональных данных на обработку.",
                "Необходимость заключения и исполнения договора оказания услуг (Пользовательского соглашения/Оферты).",
                "Исполнение обязанностей, возложенных законодательством РФ.",
            ],
        },
        {
            title: "5. Передача данных третьим лицам",
            body: [
                "Мы не продаём персональные данные. Передача третьим лицам осуществляется исключительно в случаях, предусмотренных законом и настоящей Политикой.",
                "Технические подрядчики, обеспечивающие работу Сервиса (хостинг, платёжный провайдер), получают данные в объёме, необходимом для исполнения функций, на основании договоров с обязательствами о конфиденциальности.",
                "Другим пользователям видны только данные вашего публичного профиля: имя, возраст, фотографии, город (с учётом настроек приватности), описание и интересы.",
                "По запросу уполномоченных органов данные могут быть предоставлены в порядке, установленном законодательством РФ.",
            ],
        },
        {
            title: "7. Мобильное приложение",
            body: [
                "Сервис доступен в том числе в виде мобильного приложения для операционной системы Android (далее — Мобильное приложение). Настоящая Политика применяется к обработке персональных данных при использовании Мобильного приложения в полном объёме.",
                "При установке и использовании Мобильного приложения мы обрабатываем: модель устройства, версию операционной системы, версию приложения, идентификаторы приложения и устройства (в том числе push-токен), данные об открытии и использовании приложения, сведения о сбоях — для обеспечения работы и безопасности Мобильного приложения.",
                "Мобильное приложение взаимодействует с серверной частью Сервиса через защищённое соединение (HTTPS). Учётные данные и данные профиля хранятся на стороне Оператора; на устройстве хранятся только данные, необходимые для работы приложения.",
                "Push-уведомления (в том числе через RuStore Push) направляются на устройство только с вашего согласия, полученного в момент включения уведомлений в настройках Мобильного приложения. Вы можете в любой момент отключить push-уведомления в настройках устройства или приложения — после этого push-токен перестаёт использоваться для доставки уведомлений.",
                "Распространение Мобильного приложения осуществляется через магазин приложений RuStore. Мы не передаём RuStore персональные данные вашего профиля; обработка данных самим магазином приложений регулируется его собственными условиями.",
                "Мобильное приложение предназначено для лиц, достигших возраста 18 лет.",
            ],
        },
        {
            title: "8. Модерация контента",
            body: [
                "В Сервисе пользователи размещают контент (анкеты, фотографии, сообщения) самостоятельно. Мы проводим модерацию: проверяем анкеты и фотографии при публикации и реагируем на жалобы пользователей.",
                "Для рассмотрения жалоб и принятия мер по блокированию нарушителей мы обрабатываем данные нарушителя и автора жалобы в объёме, необходимом для проверки жалобы и предотвращения повторных нарушений.",
                "При нарушении правил Сервиса (в том числе правил размещения контента) учётная запись может быть ограничена или удалена. Данные, необходимые для рассмотрения апелляций и предотвращения повторных регистраций нарушителей, сохраняются в установленном законом порядке.",
            ],
        },
        {
            title: "9. Хранение и защита",
            body: [
                "Персональные данные обрабатываются и хранятся на территории Российской Федерации.",
                "Применяются организационные и технические меры защиты: шифрование паролей и чувствительных данных, защищённые соединения (HTTPS), разграничение доступа, регулярный аудит безопасности.",
                "Данные хранятся до удаления учётной записи. После запроса на удаление аккаунта данные удаляются в течение 30 дней, за исключением случаев, когда законодательство РФ требует их дальнейшего хранения.",
            ],
        },
        {
            title: "10. Ваши права",
            body: [
                "Вы вправе получить информацию об обрабатываемых данных, потребовать их уточнения, блокирования или уничтожения, отозвать согласие на обработку.",
                `Для реализации прав напишите на ${CONTACT} или воспользуйтесь разделом «Поддержка».`,
                "Вы также вправе обжаловать действия Оператора в Роскомнадзоре или в судебном порядке.",
            ],
        },
        {
            title: "11. Изменение Политики",
            body: [
                "Оператор вправе обновлять настоящую Политику. Актуальная редакция размещается на этой странице.",
                "Продолжение использования Сервиса после публикации новой редакции означает согласие с её условиями.",
            ],
        },
    ],
};
